import React, { useEffect, useRef, useState } from 'react';
import s from './NotesSection.module.css';
import { formatDateToMonthDay } from '../../../../shared/helpers/transformData';
import ImgNote from '../../../../assets/img/note.svg';
import { Note } from '../../../../shared/types/notesTypes';
import { useSelector } from 'react-redux';
import { selectNotes } from '../../../../store/selectors/noteSelectors';
import { useAppDispatch } from '../../../../store/store';
import { updateProjectNote } from '../../../../store/slices/notesSlice';
import { selectCurrentProject } from '../../../../store/selectors/projectSelectors';
const NotesSection: React.FC = () => {
    const [selectedNote, setSelectedNote] = useState<Note | null>(null);
    const [editedNote, setEditedNote] = useState<Note | null>(null);
    const notes = useSelector(selectNotes);
    const noteDetailRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const currentProject = useSelector(selectCurrentProject);

    console.log('notes', notes);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (noteDetailRef.current && !noteDetailRef.current.contains(event.target as Node)) {
                if (selectedNote && editedNote && editedNote.content !== selectedNote.content) {
                    dispatch(
                        updateProjectNote({
                            noteId: editedNote.id,
                            content: editedNote.content,
                            projectId: currentProject?.id as string,
                        }),
                    );
                }
                setSelectedNote(null);
                setEditedNote(null);
            }
        };

        if (selectedNote) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [selectedNote, editedNote, dispatch]);

    if (notes.length === 0) {
        return null;
    }

    const handleNoteSelect = (note: Note) => {
        setSelectedNote(note);
        setEditedNote(note);
    };

    return (
        <div className={s.notes_container}>
            <p className={s.header}>Notes:</p>
            {selectedNote ? (
                <div className={s.note_detail} ref={noteDetailRef}>
                    <h2 className={s.title}>
                        {selectedNote.title} — {formatDateToMonthDay(selectedNote.createdAt)}
                    </h2>
                    <div className={s.divider} />
                    <textarea
                        className={s.content}
                        value={editedNote?.content ?? ''}
                        onChange={(e) =>
                            setEditedNote(
                                editedNote ? { ...editedNote, content: e.target.value } : null,
                            )
                        }
                    />
                </div>
            ) : (
                <div className={s.note_list}>
                    {notes.map((note) => (
                        <div
                            key={note.id}
                            className={s.note_card}
                            onClick={() => handleNoteSelect(note)}
                        >
                            <img src={ImgNote} className={s.note_icon} alt="note icon" />
                            <span className={s.date}>{formatDateToMonthDay(note.createdAt)}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default NotesSection;
